const orderConfirm = resolve => require(['@/views/paymentLink/orderConfirm/index.vue'], resolve) // 主页
const orderConfirmV2 = resolve => require(['@/views/paymentLink/orderConfirm/indexV2.vue'], resolve) // 支付链确认页

const orderConfirmV3 = resolve => require(['@/views/paymentLink/orderConfirm/indexV3.vue'], resolve) // 支付链确认页 v3
const payment404 = resolve => require(['@/views/paymentLink/orderConfirm/payment404.vue'], resolve) // 主页
const springAirlines = resolve => require(['@/views/paymentLink/orderConfirm/springAirlines.vue'], resolve) // 主页
// const main = resolve => require(["views/index/index.vue"], resolve); // 主页

export default [
  {
    path: '/paymentLink',
    component: orderConfirm
  },
  {
    path: '/paymentLinkV2',
    component: orderConfirmV2
  },
  {
    path: '/paymentLinkV3',
    component: orderConfirmV3
  },
  {
    path: '/payment404',
    component: payment404
  },
  {
    // 春秋航空支付链
    path: '/springAirlines',
    component: springAirlines
  },
]
